import { colorNeutralBackground1Hover, colorNeutralForeground1, colorNeutralForeground1Hover, colorNeutralStroke2, colorSubtleBackgroundHover, display, fontSizeBase300, fontWeightRegular, lineHeightBase300, spacingHorizontalS, strokeWidthThin } from "@fluentui/web-components";
import { sizeVerticalXXXL } from "@fabric-msft/theme";
import { css } from "@microsoft/fast-element";
export const styles = css `
  ${display("table")}

  table {
    border-collapse: collapse;
    min-width: 510px; /* @design-token-ok */
    table-layout: fixed;
    display: table;
    width: 100%;
    font-size: ${fontSizeBase300};
    line-height: ${lineHeightBase300};
  }

  .table-sort-button {
    all: unset;
    align-items: center;
    cursor: pointer;
    font: inherit;
    color: inherit;
    outline-style: none;
    min-height: ${sizeVerticalXXXL};
    box-sizing: content-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${colorNeutralForeground1};
    font-weight: ${fontWeightRegular};
    text-align: start;
  }

  tr {
    display: table-row;
    box-sizing: border-box;
    color: ${colorNeutralForeground1};
    border-bottom: ${strokeWidthThin} solid ${colorNeutralStroke2};
  }

  tbody tr:hover {
    color: ${colorNeutralForeground1Hover};
    background-color: ${colorSubtleBackgroundHover};
  }

  th {
    color: ${colorNeutralForeground1};
    text-align: start;
    font-weight: ${fontWeightRegular};
    vertical-align: middle;
    padding: 0px ${spacingHorizontalS};
    border-collapse: collapse;
  }

  th div {
    outline-style: none;
    min-height: 32px; /* @design-token-ok */
    box-sizing: content-box;
    display: flex;
    align-items: center;
  }

  th[data-table-cell-focus="true"] {
    outline: -webkit-focus-ring-color auto 1px;
  }

  :host([sortable]) th:hover {
    cursor: pointer;
    background-color: ${colorNeutralBackground1Hover};
  }

  td,
  fabric-table-cell {
    height: 44px; /* @design-token-ok */
    padding: 0px ${spacingHorizontalS};
    vertical-align: middle;
    color: ${colorNeutralForeground1};
  }

  .visually-hidden {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important; /* @design-token-ok */
    border: 0 !important;
  }
`;
//# sourceMappingURL=table.styles.js.map